import { render } from "./SocialMediaPage.vue?vue&type=template&id=5f04b1c2"
import script from "./SocialMediaPage.vue?vue&type=script&lang=js"
export * from "./SocialMediaPage.vue?vue&type=script&lang=js"

import "./SocialMediaPage.vue?vue&type=style&index=0&id=5f04b1c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__